import { Field, Form, FormElement } from '@progress/kendo-react-form';
import React, { useState } from 'react';
import {
  ButtonWrapper, CreateItemFormProps, FieldWrapper, FormInput, Link, PrimaryButtonStyled, SecondaryButtonStyled
} from './FormElements';

import { validators } from '../utils';

export const CreateCustomComponentItemForm = ({
  initialValues,
  onSubmit,
  onHandleBack,
  RenderInfo = () => <></>
 }: CreateItemFormProps) => {
  const [ isDescriptionShowed, showDescription ] = useState<boolean>(false);
  const [ isNeedSetMapping, setIsNeedSetMappingFlag] = useState<boolean>(true);

  return (
    <>

      <RenderInfo />

      <Form
        initialValues={initialValues}
        onSubmitClick={(data) => {
          const formData  = {
            ...data.values,
            isNeedSetMapping
          };
          // @ts-ignore
          onSubmit(formData)
        }}
        render={(formRenderProps) => (
          <FormElement>
            <fieldset className={'k-form-fieldset'}>
              <Field
                id='name'
                name='name'
                label='Name'
                autoFocus={true}
                component={FormInput}
                validator={validators.nameValidator}
              />

              { !isDescriptionShowed && (
                <FieldWrapper>
                  <Link handleClick={() => showDescription(true)}>Add description</Link>
                </FieldWrapper>
              ) }

              { isDescriptionShowed && (
                <Field
                  id='description'
                  name='description'
                  label='Description'
                  optional={true}
                  component={FormInput}
                />
              ) }

              <ButtonWrapper>
                {/*@ts-ignore*/}
                <PrimaryButtonStyled
                  // @ts-ignore
                  type='submit'
                  disabled={!formRenderProps.valueGetter('name') || !formRenderProps.valid}
                >
                  Next: set mapping
                </PrimaryButtonStyled>

                <SecondaryButtonStyled
                  onClick={() => {
                    setIsNeedSetMappingFlag(false);
                  }}
                  disabled={!formRenderProps.valueGetter('name') || !formRenderProps.valid}
                >
                  Set mapping later
                </SecondaryButtonStyled>

              </ButtonWrapper>
            </fieldset>
          </FormElement>
        )}
      />
    </>
  );
};
